import {
	AiOutlineLink,
	AiFillLinkedin,
	AiOutlineWhatsApp,
	AiOutlineMail,
} from "react-icons/ai"

export const socials = [
	{
		link: "https://iamshour.com",
		icon: <AiOutlineLink className='icon' />,
	},
	{
		link: "https://www.linkedin.com/in/alishour/",
		icon: <AiFillLinkedin className='icon' />,
	},
	{
		link: "https://wa.me/96171230387",
		icon: <AiOutlineWhatsApp className='icon' />,
	},
	{
		link: "mailto:iamshour@outlook.com",
		icon: <AiOutlineMail className='icon' />,
	},
]
